import { THEMES, ThemeColors, ThemesEnum } from './types';

export const getThemeColors = (theme?: ThemesEnum): ThemeColors => {
	switch (theme) {
		case ThemesEnum.dark:
			return THEMES.dark;
		case ThemesEnum.light:
			return THEMES.light;
		default:
			return THEMES.light;
	}
};
